<template>
    <v-dialog max-width="450" persistent v-model="dialog">
        <v-card v-if="showConfirmationDialog">
            <v-card-title class="headline">Confirmation</v-card-title>
            <v-card-text>
                <v-card>
                    <v-card-text>
                        <p>GFI Scores for this customer has been generated already. Please confirm you want to change the details for this customer. Please note that doing so will remove the current scores and new
                        score will have to be generated.</p>
                        <p>Do you want to proceed ?</p>
                        <v-card-actions>
                            <v-btn class="primary" @click="destroy" >Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn class="primary" @click="hideConfirmationDialog">Confirm</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-title class="headline">Edit Customer Information</v-card-title>
            <v-card-text>
                <ValidationObserver ref="observer" v-slot="{failedRules, failed ,passes}">
                    <form>
                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider vid="applicationNumber" name="applicationNumber"
                                                :rules="{numeric:true, max:10 }" ref="observerEditApplicationNumber"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                              class="requiredSticker"
                                              label="Application Number" v-model="customer.applicationNumber"></v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required: true, min : 5, max : 80, regex:/^[a-zA-Z\s-/@']+$/ }"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'fullName')"
                                              readonly
                                              label="Full Name" v-model="customer.fullname"></v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required : true, max:16, regex: /^[a-zA-Z0-9]+$/}"
                                                name="idNumber"
                                                v-slot="{ errors, failedRules }">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'idNumber')"
                                              readonly
                                              label="Identification Number (ID)"
                                              v-model="customer.idNumber">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required:true}" v-slot="{errors, failedRules}">
                                <v-select :error-messages="$translatedErrorMessages(failedRules,'gender')"
                                          class="requiredSticker"
                                          :items="dropdown.genders"
                                          item-text="text"
                                          item-value="value"
                                          label="Gender"
                                          v-model="customer.gender">
                                </v-select>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required: true ,min:2, max:100, regex:/^[a-zA-Z.&-(),/%'\s-]+$/ }"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'position')"
                                              class="requiredSticker"
                                              label="Position" v-model="customer.designation"></v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required: true, max:15, regex: /^[a-zA-Z0-9]+$/ }"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'brNumber')"
                                              class="requiredSticker" readonly
                                              label="Business Registration Number"
                                              v-model="customer.businessRegistrationNumber">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{required: true, min:5, max:80, regex:/^[a-zA-Z0-9.&()'\s-]+$/ }"
                                    v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'companyName')"
                                              class="requiredSticker"
                                               label="Company Name" v-model="customer.companyName">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <v-menu ref="menu" v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <ValidationProvider :rules="{required: true }" v-slot="{errors, failedRules}">
                                    <v-text-field
                                            :error-messages="$translatedErrorMessages(failedRules,'editedCommencementDate')"
                                            class="requiredSticker"
                                            label="Date of Business Commencement" append-icon="mdi-calendar"
                                            v-model="editedCommencementDate"
                                            v-on="on"></v-text-field>
                                    </ValidationProvider>
                                </template>

                                <v-date-picker color="#81c342" :max="date" v-model="customer.commencementDate"
                                               @input="menu = false"
                                               no-title scrollable>
                                </v-date-picker>
                            </v-menu>

                        </v-skeleton-loader>

                        <v-skeleton-loader
                                :loading="loading"
                                transition="scale-transition"
                                type="list-item-two-line">
                            <v-select :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                                      class="requiredSticker"
                                      :items="dropdown.businessCategories"
                                      item-text="text"
                                      item-value="value"
                                      label="Business Category"
                                      v-model="customer.businessCategory"
                            ></v-select>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required : true}" name="product"
                                                v-slot="{ errors, failedRules }">
                                <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product')"
                                                readonly
                                                :items="$parent.filters.scheme"
                                                item-text="label"
                                                item-value="code"
                                                label="Product Applied"
                                                v-model="customer.productApplied"
                                ></v-autocomplete>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader
                                :loading="loading"
                                transition="scale-transition"
                                type="list-item-two-line">
                            <ValidationProvider :rules="{required: true, min : 1, max : 3, regex:/^[a-zA-Z0-9\s-+#@]+$/ }"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'internalRating')"
                                              label="Internal Credit Rating"
                                              class="requiredSticker"
                                              v-model="customer.internalRating"></v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1, max_value:10000}" v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'employeesCount')"
                                              label="Number of full-time employee"
                                              class="requiredSticker"
                                              v-model="customer.employeesCount"/>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{ required: true, numeric: true, min_value: 0, max_value:999999999999}" v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'annualSales')"
                                              prefix="Rp" class="requiredSticker"
                                              label="Annual Sales"
                                              v-model="customer.annualSales"/>
                            </ValidationProvider>
                        </v-skeleton-loader>
                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{ required: false, numeric: true, min_value: 0, max_value:customer.annualSales}" v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'annualProfit')"
                                              label="Annual Profit" class="requiredSticker"
                                              prefix="Rp"
                                              v-model="customer.annualProfit"/>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: true, numeric: true, min_value: selectedProduct.validation.minAmount, max_value : selectedProduct.validation.maxAmount}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount', [selectedProduct.validation.minAmount, selectedProduct.validation.maxAmount])"
                                        class="requiredSticker"
                                        label="Financing Amount Applied"
                                        prefix="Rp"
                                        v-model="customer.loanAmount">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: true, numeric: true, min_value: selectedProduct.validation.minTenure, max_value : selectedProduct.validation.maxTenure}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied', [selectedProduct.validation.minTenure, selectedProduct.validation.maxTenure])"
                                        class="requiredSticker"
                                        label="Financing Tenure Applied"
                                        required
                                        suffix="Months"
                                        v-model="customer.tenureApplied">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>
                        <div>
                            <div v-show="failed">
                                <p style="color:red" >One or more customer information have errors, please provide correct information to save successfully</p>
                            </div>
                            <div v-show="serverError">
                                <p style="color:red" >Something went wrong. Please try again later</p>
                            </div>
                        </div>
                        <v-card-actions align="right">
                            <v-spacer></v-spacer>
                            <v-skeleton-loader class="mr-3" :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="destroy" color="primary">Cancel</v-btn>
                            </v-skeleton-loader>
                            <v-skeleton-loader :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="passes(saveCustomer)" color="primary" dark>Save
                                </v-btn>
                            </v-skeleton-loader>
                        </v-card-actions>
                    </form>
                </ValidationObserver>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {dataServices} from "@/services";

    export default {
        name: 'CustomerMaintenance',
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                loading: false,
                dialog: false,
                menu: false,
                customer: {},
                dropdown: {},
                branches:[],
                date: new Date().toISOString().substr(0, 10),
                editedCommencementDate:'',
                editBusinessCategoryDropdownData: [],
                validation: false,
                selectedProduct: {
                    validation: {
                        minAmount: 100000000,
                        maxAmount: 10000000000,
                        minTenure: 2,
                        maxTenure: 12
                    }
                },
                malaysianOwnedItems: [
                    {text: 'Yes', value: 'Yes'},
                    {text: 'No', value: 'No'}
                ],
                errors: [],
                showConfirmationDialog: false,
                failed: false,
                serverError: false,
                sending: false
            }
        },
        methods: {
            init(customer, validation) {
                this.loading = true
                this.customer = Object.assign({}, customer)
                this.validation = validation
                if (this.customer.gfiScoreGenerationCount === null || (this.customer.gfiScoreGenerationCount > 0 && !this.customer.hasGfiScore) ){
                    this.showConfirmationDialog = false
                } else if(this.customer.gfiScoreGenerationCount === 1) {
                    this.showConfirmationDialog = true
                }
                this.initDropdown()
                this.dialog = true
            },
            initDropdown: function () {
                dataServices.getUserDropDowns(this.$parent.userType.toUpperCase()).then(response => {
                    this.dropdown = response.dataResponse
                    this.branches = response.dataResponse.branch
                    this.loading = false
                })
            },
            saveCustomer() {
                this.sending=true
                dataServices.saveCustomer(this.customer).then(r => {
                    this.sending=false
                    if (r.successful) {
                        this.$parent.renderMessage('Successfully updated customer information.')
                        this.dialog = false
                    } else {
                        r.errorList.forEach(e => {
                            if(e.field==='applicationNumber' && e.rule==='duplicate'){
                                this.$refs.observerEditApplicationNumber.applyResult({
                                    errors: ['error'],
                                    failedRules: ['duplicate']
                                });
                            }
                        })
                    }
                }).catch(error => {
                    this.sending=false
                    this.serverError = true
                    console.log('Error' + error)
                })
            },
            hideConfirmationDialog() {
                this.showConfirmationDialog = false
            },
            destroy() {
                this.dialog = false
            }
        },
        watch: {
            'customer.commencementDate': function () {
                if (this.customer.commencementDate) {
                    const [year, month, day] = this.customer.commencementDate.substr(0, 10).split('-')
                    this.editedCommencementDate = `${day}-${month}-${year}`
                } else
                    this.editedCommencementDate = ''
            },
            editedCommencementDate: function (newCommencementDate) {
                if (!newCommencementDate) {
                    this.customer.commencementDate = null
                }
            },
        }
    }
</script>

<style>
    .requiredSticker label::after {
        content: "*";
        color: red;
    }
</style>
